import { home } from "./home";
import { layout } from "./layout";
import { nav } from "./nav";
import { pages } from "./pages";

const en = { nav, layout, home, pages };

export default en;
